import { Grid } from "@mui/material";
import { getTime } from "date-fns";
import { useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormSection from "../../../common/components/functional/formSection/FormSection";
import {
  PriceValueType,
  SingleOverrideItem,
} from "../../tesPricingOverride/tesPricingOverrideAPI";
import { SupplementPriceOverridesType } from "../../../common/types/apiTypes";
import TesPricingOverride from "../../tesPricingOverride/tesPricingOverrideUI/TesPricingOverride";

const OrderTemplateSupplementPriceOverrides = () => {
  const [tesPricingOverridesOpen, setTesPricingOverridesOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  const { watch, setValue } = useFormContext();
  const watchedTes = watch("tes");
  const watchedSupplementPriceOverrides = watch("supplementPriceOverrides");

  const onAdd = (item: SingleOverrideItem) => {
    const { key, value, unit } = item;
    const updatedOverrides: SupplementPriceOverridesType = {
      ...watchedSupplementPriceOverrides,
      [key]: {
        value,
        unit: unit as PriceValueType,
      },
    };
    setValue("supplementPriceOverrides", updatedOverrides, {
      shouldDirty: true,
    });
    return true;
  };

  const onEdit = (item: SingleOverrideItem) => {
    const { key, value, unit } = item;

    const updatedOverride = {
      ...watchedSupplementPriceOverrides[key],
      value,
      unit,
    };
    const updatedOverrides = {
      ...watchedSupplementPriceOverrides,
      [key]: updatedOverride,
    };

    setValue("supplementPriceOverrides", updatedOverrides, {
      shouldDirty: true,
    });
    return true;
  };

  const onDelete = (key: string) => {
    const updatedOverrides = { ...watchedSupplementPriceOverrides };
    delete updatedOverrides[key];
    setValue("supplementPriceOverrides", updatedOverrides, {
      shouldDirty: true,
    });
    return true;
  };

  const modalTitle = t(
    "tesPricingOverride:editTesPricingOverride",
  ).toUpperCase();
  const modalItemSelectLabel = t("tesPricingOverride:selectItem");
  const modalItemValueLabel = t("tesPricingOverride:selectValueLabel");

  const epoch = useMemo(() => getTime(new Date()), []);

  return (
    <FormSection
      title={t("order:salaryCategoryValues")}
      collapse
      open={tesPricingOverridesOpen}
      toggleOpen={() => setTesPricingOverridesOpen(!tesPricingOverridesOpen)}
    >
      <Grid item xs={3} />
      <Grid item xs={9}>
        <TesPricingOverride
          tesId={watchedTes?.id}
          date={epoch}
          tesPricingOverrideItems={watchedSupplementPriceOverrides}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          onEdit={onEdit}
          onAdd={onAdd}
          onDelete={onDelete}
          modalTitle={modalTitle}
          modalItemSelectLabel={modalItemSelectLabel}
          modalItemValueLabel={modalItemValueLabel}
          tableWidth="100%"
          editable
        />
      </Grid>
    </FormSection>
  );
};

export default OrderTemplateSupplementPriceOverrides;
